<template>
	<div class="container">
		<div class="page page-products">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Products') }}</h1>
					</div>
					<div class="col-md-3">
						<div class="page-header-right text-right">
							<!-- Date Filter -->
							<daterangepicker
								class="hidden"
								:presets="filterDatePresets"
								:start="since"
								:end="until"
								@selected="setFilterDate"
							>
							</daterangepicker>
						</div>
					</div>
				</div>
			</div>

			<product-stats
				:stats="stats"
				:is-show-label="false"
				:is-show-info="isShowInfo"
				:clickable="true"
				:status="status"
				:selected-overviews="productStatsOverviews"
				@action="overviewAction">
			</product-stats>

			<!-- Overviews -->
			<!-- <div class="submissions-summaries">
			<div class="overviews">
				<div class="row">
					<div class="col-md-4">
						<overview
							:number="totalProducts"
							:type="'normal'"
							:icon="'shopping-cart'"
							:icon-type="'feather'"
							:text="$t('Total Products')">
						</overview>
					</div>
					<div class="col-md-4">
						<overview
							:number="totalQtySold"
							:type="'normal'"
							:icon="'shopping-cart'"
							:icon-type="'feather'"
							:text="$t('Total Quantity Sold')">
						</overview>
					</div>
					<div class="col-md-4">
						<overview
							:number="totalPaidOrder"
							:type="'normal'"
							:icon="'rupiah'"
							:text="$t('Total Paid Order')">
						</overview>
					</div>
				</div>
			</div>
		</div> -->

			<!-- Table Menu -->
			<div class="table-list-menu d-lg-flex align-items-center">
				<div class="table-actions d-flex align-items-center flex-wrap">
					<!-- Add Product -->
					<a
						v-if="isUserCan('product_add')"
						href="/products/new"
						class="btn btn-primary btn-sm flex-center mr-2"
					>
						<i class="material-icons">add</i>
						<span>{{ $t('Add Product') }}</span>
					</a>

					<!-- Bulk Archive -->
					<!-- <button type="button" class="btn btn-light btn-icon btn-sm btn-icon-primary mr-2"
					:disabled=" !isCanArchive || selectedProducts.length === 0"
					@click="isShowArchiveProductBulk = true"
					v-tooltip="'Archive Product'">
						<i class="material-icons">archive</i> Archive
					</button> -->

					<!-- Bulk Delete -->
					<button
						class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
						:class="{ 'is-loading': isDeleting }"
						:disabled="!isCanDelete || selectedProducts.length === 0"
						@click="isShowDeleteProductBulk = true"
						v-if="isCanDeleteProduct && isDropshipper"
					>
						<i class="material-icons">delete</i>
						<span>{{ $t('Delete') }}</span>
					</button>

					<!-- Import -->
					<button
						v-if="isUserCan('product_add')"
						class="btn btn-light btn-icon btn-sm mr-1"
						:class="{ 'is-loading': isImporting }"
						@click="openProductsImportModal">
						<i class="material-icons mr-1">upload</i>
						<span>{{ $t('Import') }}</span>
					</button>

					<!-- Selected Label -->
					<div
						class="btn btn-plain btn-sm d-flex align-items-center disabled"
						v-if="selectedProducts && selectedProducts.length > 0"
					>
						{{ selectedProducts.length }} {{ $t('Selected Products') }}
					</div>
				</div>

				<div class="table-filters text-right d-flex align-items-center ml-a">
					<!-- Clear Filter -->
					<button
						type="button"
						class="btn btn-plain btn-sm"
						@click="clearFilter"
						v-if="isFilterOn"
					>
						{{ $t('Clear Filter') }}
					</button>
					<!-- Filter -->
					<button
						type="button"
						class="filter-toggle btn btn-light btn-sm btn-icon"
						@click="isShowFilter = true"
					>
						<i class="material-icons">filter_list</i>
						<span>{{ $t('Filter') }}</span>
					</button>
					<!-- Search Keyword -->
					<input
						type="text"
						class="input form-control form-control-sm products-search-box"
						:placeholder="`${$t('Search')}..`"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>

			<!-- New Order Notice -->
			<div class="alert alert-info text-center" v-if="newProducts.length > 0">
				<span
					>You have imported <b>{{ newProducts.length }}</b> new products.
				</span>
				<a class="link alert-link" @click="refreshPage">{{
					$t('Click here to Refresh')
				}}</a>
			</div>

			<!-- Main Table -->
			<div class="products-list table-responsive" v-if="isRouteChecked">
				<table
					class="products-list-table table table-primary table-striped mb-0"
				>
					<thead>
						<tr>
							<th width="5%" class="th-checkbox">
								<label class="input-checkbox-container">
									<input
										type="checkbox"
										class="input-checkbox"
										v-model="selectAll"
									/>
									<span></span>
								</label>
							</th>
							<th width="7%" class="th-product-image"></th>
							<th
								class="th-sort text-left"
								:class="sortClass('name')"
								@click="changeSorting('name')"
							>
								{{ $t('Name') }}
							</th>
							<th
								width="10%"
								class="th-sort hidden-sm"
								:class="sortClass('price')"
								@click="changeSorting('price')"
							>
								{{ $t('Price') }}
							</th>
							<th
								width="10%"
								class="th-sort hidden-sm"
								:class="sortClass('status')"
								@click="changeSorting('status')"
								v-if="isSupplier"
							>
								{{ $t('Status') }}
							</th>
							<!-- <th class="hidden-sm">{{ $t('COGS') }}</th> -->
							<th class="hidden-sm text-right">{{ $t('menu.inventory') }}</th>
							<!-- <th width="8%" class="th-sort hidden-sm" :class="sortClass('submission_count')" @click="changeSorting('submission_count')">{{ $t('Order') }}</th> -->
							<!-- <th width="8%" class="th-sort hidden-sm" :class="sortClass('transaction_count')" @click="changeSorting('transaction_count')">{{ $t('Paid') }}</th> -->
							<!-- <th width="8%" class="th-sort hidden-sm" :class="sortClass('paid_ratio')" @click="changeSorting('paid_ratio')">{{ $t('Paid Ratio') }}</th> -->
							<!-- <th width="8%" class="th-sort hidden-sm" :class="sortClass('quantity')" @click="changeSorting('quantity')">{{ $t('Qty Sold') }}</th> -->
							<!-- <th class="th-sort" :class="sortClass('gross_revenue')" @click="changeSorting('gross_revenue')">Gross Revenue</th> -->
							<!-- <th width="10%" class="th-sort hidden-sm" :class="sortClass('net_revenue')" @click="changeSorting('net_revenue')" v-if="isUserCan('statistic_net_revenue')">{{ $t('Net Revenue') }}</th> -->
						</tr>
					</thead>
					<tbody>
						<tr v-for="product in products" :key="product._id.$oid" :class="{ 'd-none': isHideProduct(product) }">
							<td class="align-middle">
								<label class="input-checkbox-container">
									<input
										type="checkbox"
										class="input-checkbox"
										:value="product._id.$oid"
										v-model="selectedProducts"
									/>
									<span></span>
								</label>
							</td>

							<!-- Product Image -->
							<td class="align-middle p-0">
								<router-link
									v-if="isUserCan('product_edit')"
									:to="{
										name: 'productEdit',
										params: {
											id: product._id.$oid ? product._id.$oid : product._id,
										},
									}"
								>
									<!-- <div class="product-image m-auto" :style="{ backgroundImage: `url(${product.pictures[0]})` }"></div> -->
									<!-- <div class="product-image" :style="{ backgroundImage: `url(${product.pictures[0]})` }"></div> -->
									<div
										class="product-image"
										:style="{
											backgroundImage: `url(${
												product.picture && product.picture !== ''
													? product.picture
													: 'https://cdn.ostock.id/img/default-product.png'
											})`,
										}"
									></div>
								</router-link>
								<div
									v-else
									class="product-image"
									:style="{
										backgroundImage: `url(${
											product.picture && product.picture !== ''
												? product.picture
												: 'https://cdn.ostock.id/img/default-product.png'
										})`,
									}"
								></div>
							</td>
							<!-- Product Name -->
							<td>
								<div class="product-name">
									<router-link
										v-if="isUserCan('product_edit')"
										class="product-name-text"
										:to="{
											name: 'productEdit',
											params: {
												id: product._id.$oid ? product._id.$oid : product._id,
											},
										}"
									>
										<span class="va-m d-block">{{ product.name }}</span>
									</router-link>
									<span v-else class="va-m cursor-pointer text-primary text-bold d-block" @click="showProductDetail(product)">{{ product.name }}</span>
									<div v-if="product.visibility"  class="d-inline">
										<badges  class="d-inline" :is-private-enabled="product.visibility === 'private'"></badges>
									</div>
									<div v-if="product.is_deleted && isDropshipper" class="d-inline gx-3">
										<badges  class="d-inline" :is-deleted-product="product.is_deleted"></badges>
									</div>
									<div class="visible-sm w-100">
										<div class="group">
											<span>Price: {{ formatMoney(product.price) }}</span>
										</div>
									</div>
									<div class="row-actions hidden-sm">
										<a @click="showConfirmDuplicateProduct(product)" v-if="isUserCan('product_add') && !product.is_deleted">
											<i class="material-icons md-xs">content_copy</i>
											<span>{{ $t('Duplicate') }}</span>
										</a>
										<!-- <router-link :to="{ name: 'productEdit', params: { id: product._id } }" v-if="isUserCan('product_edit')"><i class="material-icons md-xs">edit</i> Edit</router-link> -->
										<a
											@click="showConfirmDeleteProduct(product)"
											v-if="isUserCan('product_delete') && (!product.submission_count || product.submission_count < 1) && isDropshipper && !product.is_deleted"
										>
											<i class="material-icons md-xs">delete</i>
											<span>{{ $t('Delete') }}</span>
										</a>
										<a
											target="_blank" :href="product.marketing_kit.link"
											v-if="isShowMarketingKit(product)"
										>
											<i class="material-icons md-xs">download</i>
											<span>{{ $t('Marketing Kit') }}</span>
										</a>
										<a
											@click="openLinkProduct(product)"
											:class="{ 'is-loading': isFetchingLink }"
										>
											<span v-if="!isFetchingLink">
												<i class="material-icons md-xs">open_in_new</i>
												<span>{{ $t('Link Product') }}</span>
											</span>
										</a>
									</div>
								</div>
							</td>
							<!-- Price -->
							<td class="hidden-sm">
								<div class="product-price text-right">
									{{ formatMoney(product.price) }}
								</div>
							</td>
							<!-- Status -->
							<td v-if="isSupplier">
								<div class="text-center" v-if="product.is_deleted">
									<span class="deleted">
										<i class="material-icons mr-1 d-inline">circle</i>
										<div class="text-capitalize d-inline">
											<span v-if="!product.is_deleted">Active</span>
											<span v-else>Deleted</span>
										</div>
									</span>
								</div>
								<div
									v-if="!product.is_deleted"
									class="product-status text-center"
									:class="getProductDisplayStatus(product.status).color"
								>
									{{ getProductDisplayStatus(product.status, product.is_verified).status }}
								</div>
							</td>

							<!-- COGS -->
							<!-- <td class="hidden-sm">
							<div
								class="product-price text-right"
								v-if="product.cogs && (isOwner || isUserCan('statistic_cogs'))">
								{{ formatMoney(product.cogs) }}
							</div>
							<div class="product-price text-center" v-else>-</div>
						</td> -->

							<!-- Inventory -->
							<td class="hidden-sm">
								<div class="product-inventory text-right">
									<template v-if="product.stock.enabled">
										<button
											type="button"
											class="btn btn-text"
											@click="showStock(product)"
											v-tooltip="'Show stock'"
										>
											<b
												class="text-success"
												v-if="getStockQuantity(product) > 10"
											>
												<span>{{ getStockQuantity(product) }} in stock</span>
											</b>
											<b
												class="text-danger"
												v-else-if="getStockQuantity(product) > 0 && getStockQuantity(product) <= 10"
											>
												<span>{{ getStockQuantity(product) }} in stock</span>
											</b>
											<b
												class="text-danger"
												v-else
												>{{ $t('Out of stock') }}</b
											>
										</button>
										<div class="row-actions">
											<router-link
												:to="`/inventory?product_id=${product._id.$oid}`"
												class="btn btn-text"
											>
												<i class="material-icons">history</i>
												<span>{{ $t('View History') }}</span>
											</router-link>
										</div>
									</template>
									<div v-else>-</div>
								</div>
							</td>

							<!-- Submission -->
							<!-- <td class="hidden-sm">
							<div class="product-submission">
								<div class="product-submission-value">{{ formatNumberPlain(product.submission_count) }}</div>
								<div class="row-actions">
									<router-link :to="{ name: 'submissions', query: { product_id: product._id.$oid } }">
										<i class="material-icons md-xs">remove_red_eye</i>
										<span class="ml-1">{{ $t('Orders') }}</span>
									</router-link>
								</div>
							</div>
						</td> -->

							<!-- Transaction -->
							<!-- <td class="hidden-sm">
							<div class="product-transaction text-center">
								<div class="product-transaction-value">{{ formatNumberPlain(product.transaction_count) }}</div>
							</div>
						</td> -->

							<!-- Paid Ratio -->
							<!-- <td class="hidden-sm">
							<div class="product-transaction text-center">
								<div class="product-transaction-value">
									<span v-if="product.paid_ratio">{{ product.paid_ratio }}%</span>
									<span v-else>0%</span>
								</div>
							</div>
						</td> -->

							<!-- Quantity Sold -->
							<!-- <td class="hidden-sm">
							<div class="product-transaction text-center">
								<div class="product-transaction-value">
									<span v-if="product.quantity">{{ product.quantity }}</span>
									<span v-else>0</span>
								</div>
							</div>
						</td> -->

							<!-- Gross Revenue -->
							<!-- <td class="hidden-sm text-right">
							<div class="product-gross">{{ formatMoney(product.gross_revenue) }}</div>
						</td> -->

							<!-- Revenue -->
							<!-- <td class="hidden-sm text-right" v-if="isUserCan('statistic_net_revenue')">
							<div class="product-revenue">{{ formatMoney(product.net_revenue) }}</div>
						</td> -->
						</tr>
						<!-- <tr class="row-empty" v-if="searchResultsEmpty">
						<td colspan="7">
							<div class="list-empty"><i class="material-icons md-48">error_outline</i> No products meet your search query.</div>
						</td>
					</tr> -->
					</tbody>
				</table>
				<!-- <div class="list-empty" v-if="isNoProducts"><i class="material-icons">error_outline</i> You haven't created any products yet.</div> -->
				<div
					class="list-empty table-empty"
					v-if="products.length === 0 && isFetching === false"
				>
					<i class="material-icons mr-2 va-m">error_outline</i>
					<span class="va-m" v-if="keyword === ''"
						>{{ $t("You haven't created any products yet") }}.</span
					>
					<span class="va-m" v-else>{{ $t('No products was found') }}</span>
				</div>
			</div>

			<!-- Table Loader -->
			<div class="table-fetch-status" v-if="isFetching">
				<div class="is-loading large dark m-auto"></div>
			</div>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Bulk Delete Product Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				@close="isShowDeleteProductBulk = false"
				v-if="isShowDeleteProductBulk"
			>
				<div slot="header">
					<h3>
						<i class="material-icons">delete</i>
						<span class="ml-1">{{ $t('Delete Product') }}</span>
					</h3>
				</div>
				<div slot="body">
					<p>
						{{ $t('Are you sure want to delete') }}
						{{ selectedProducts.length }} {{ $t('products') }}?<br />{{
							$t('All')
						}}
						<b>{{ $t('orders') }}</b>
						{{ $t('from these products will be deleted too') }}.
					</p>
					<p class="mb-2">
						<b>{{ $t('Products to be deleted') }}:</b>
					</p>
					<div>
						<div v-for="(product, index) in selectedProductsData" :key="index">
							<small>{{ index + 1 }}. {{ product.name }}</small>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDeleteProductBulk = false"
					>
						{{ $t('Cancel') }}
					</button>
					<button
						type="button"
						class="btn btn-danger"
						:class="{ 'is-loading': isDeleting }"
						@click="bulkDelete"
					>
						<i class="material-icons">delete</i>
						<span>{{ $t('Confirm Delete') }}</span>
					</button>
				</div>
			</modal>

			<!-- Bulk Archive Product Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				@close="isShowArchiveProductBulk = false"
				v-if="isShowArchiveProductBulk"
			>
				<div slot="header">
					<h3>
						<i class="material-icons">archive</i>
						<span class="ml-1">{{ $t('Archive Product') }}</span>
					</h3>
				</div>
				<div slot="body">
					<p>
						{{ $t('Are you sure want to archive') }}
						{{ selectedProducts.length }} {{ $t('products') }}?<br />{{
							$t('All')
						}}
					</p>
					<p class="mb-2">
						<b>{{ $t('Products to be archived') }}:</b>
					</p>
					<div>
						<div v-for="(product, index) in selectedProductsData" :key="index">
							<small>{{ index + 1 }}. {{ product.name }}</small>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowArchiveProductBulk = false"
					>
						{{ $t('Cancel') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isArchiveLoading }"
						@click="bulkArchive"
					>
						<i class="material-icons">archive</i>
						<span>{{ $t('Confirm Archive') }}</span>
					</button>
				</div>
			</modal>

			<!-- Delete Product Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				@close="isShowDeleteProduct = false"
				v-if="isShowDeleteProduct"
			>
				<div slot="header">
					<h3><i class="material-icons">delete</i>Delete Product</h3>
				</div>
				<div slot="body">
					Are you sure want to delete <b>{{ selectedProduct.name }}</b
					>?<br />All orders from this products will be deleted too.
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDeleteProduct = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-danger"
						:class="{ 'is-loading': isDeleting }"
						@click="deleteProduct"
					>
						<i class="material-icons">delete</i>
						<span>Delete</span>
					</button>
				</div>
			</modal>

			<!-- Duplicate Product -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				@close="isShowDuplicateProduct = false"
				v-if="isShowDuplicateProduct"
			>
				<div slot="header">
					<h3><i class="material-icons">content_copy</i>Duplicate Product</h3>
				</div>
				<div slot="body">
					Are you sure want to duplicate <b>{{ selectedProduct.name }}</b
					>?
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDuplicateProduct = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isDuplicatingProduct }"
						@click="duplicateProduct(selectedProduct._id.$oid)"
					>
						Duplicate
					</button>
				</div>
			</modal>

			<!-- Stock -->
			<modal
				class="coupon-editor-modal"
				size="small-medium"
				@close="isShowStock = false"
				v-if="isShowStock"
			>
				<div slot="header">
					<h3><i class="material-icons">assignment</i>Product's Stock</h3>
				</div>
				<div slot="body">
					<p class="h3 mb-3">{{ selectedProduct.name }}</p>
					<div>
						<div
							class="product-stock-info alert alert-info text-center"
							:class="{ 'alert-danger': selectedProductStock <= 0 }"
						>
							<div class="product-stock-qty">
								{{ formatNumber(selectedProductStock) }}
							</div>
							<div>Total Stock</div>
							<hr />
							<router-link
								class="btn-stock-history btn btn-text d-flex justify-content-center align-items-center"
								:to="`/inventory?product_id=${selectedProduct._id.$oid}`"
								_target="_blank"
							>
								<i class="material-icons mr-2">history</i>
								<span>See Stock History</span>
							</router-link>
						</div>
						<div v-if="selectedProduct.type === 'variable'">
							<p class="mb-2"><b>Variation's Stock</b></p>
							<div class="card">
								<div
									class="product-stock-variation d-flex justify-content-between"
									v-for="(variation, index) in selectedProduct.variations
										.prices"
									:key="index"
								>
									<div class="product-stock-variation-name">
										{{ variation.name.split('||').join(' - ') }}
									</div>
									<div class="product-stock-variation-qty">
										<div v-if="variation.stock">
											<b>{{ formatNumber(variation.stock.quantity) }}</b>
										</div>
										<div v-else>-</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- Product's Tracking -->
			<modal
				class="coupon-editor-modal"
				size="large"
				:full="true"
				:hide-footer="true"
				@close="isShowTracking = false"
				v-if="isShowTracking"
			>
				<div slot="header">
					<h3><i class="material-icons">code</i>Product's Tracking</h3>
				</div>
				<div slot="body">
					<product-tracking
						:product-ids="selectedProducts"
						:pixel-events="pixelEvents"
						:pixel-ids="pixelIds"
						:gtm-ids="gtmIds"
						@cancel="isShowTracking = false"
					>
					</product-tracking>
				</div>
			</modal>

			<!-- Product's Assignation -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				@close="isShowAssignation = false"
				v-if="isShowAssignation"
			>
				<div slot="header">
					<h3><i class="material-icons">people</i>Product's Assignation</h3>
				</div>
				<div slot="body">
					<div class="alert alert-warning mb-4">
						Please be aware, that this settings will override all assignation
						settings on the selected products.
					</div>
					<!-- Belongs To -->
					<product-belongs-to
						:product-ids="selectedProducts"
						v-bind:members.sync="members"
						v-bind:belongs-to.sync="belongsTo"
						v-bind:distribution.sync="orderDistribution"
						ref="assignation"
					>
					</product-belongs-to>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowAssignation = false"
					>
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{
							'is-loading': $refs.assignation && $refs.assignation.isSaving,
						}"
						@click="$refs.assignation.onSave()"
					>
						{{ $t('Save') }}
					</button>
				</div>
			</modal>

			<!-- Product's Visibility -->
			<modal
				class=""
				size="medium"
				:full="true"
				:hide-footer="true"
				@close="isShowEditVisibility = false"
				v-if="isShowEditVisibility"
			>
				<template slot="header">
					<h3>
						<i class="material-icons">visibility</i>Product's Visibility on
						Storefront
					</h3>
				</template>
				<template slot="body">
					<div class="p-4">
						<div class="alert alert-warning mb-4">
							Please be aware, that this settings will override all visibility
							settings on the selected products.
						</div>
						<!-- Toggle -->
						<div class="form-group">
							<!-- <label>Visible</label> -->
							<checkbox-toggle
								label="Visible on Storefront"
								v-model="isVisible"
							>
							</checkbox-toggle>
						</div>
					</div>
					<div class="modal-footer text-right">
						<button
							type="button"
							class="btn btn-primary"
							@click="updateVisibility"
						>
							Update
						</button>
					</div>
				</template>
			</modal>

			<!-- Product's Reseller -->
			<modal
				class=""
				size="medium"
				:full="true"
				:hide-footer="true"
				@close="isShowProductReseller = false"
				v-if="isShowProductReseller"
			>
				<template slot="header">
					<h3><i class="material-icons">share</i>Product's Reseller</h3>
				</template>
				<template slot="body">
					<div class="p-4">
						<div class="alert alert-warning mb-4">
							Please be aware, that this settings will override all reseller
							settings on the selected products.
						</div>
						<!-- Toggle -->
						<div class="form-group">
							<!-- <label>Visible</label> -->
							<checkbox-toggle label="Product Reseller" v-model="isReseller">
							</checkbox-toggle>
						</div>
					</div>
					<div class="modal-footer text-right">
						<button
							type="button"
							class="btn btn-primary"
							@click="updateProductReseller"
						>
							Update
						</button>
					</div>
				</template>
			</modal>

			<!-- Follow Up -->
			<modal
				class="product-follow-up-modal"
				size="large"
				:full="true"
				:hide-footer="true"
				@close="isShowFollowUp = false"
				v-if="isShowFollowUp"
			>
				<div slot="header">
					<h3><i class="material-icons">title</i>Follow-up Text</h3>
				</div>
				<div slot="body">
					<product-follow-up
						:product-ids="selectedProducts"
						@cancel="isShowFollowUp = false"
					>
					</product-follow-up>
				</div>
			</modal>

			<!-- Table Filter -->
			<modal
				class="table-filter-modal"
				size="medium"
				@close="isShowFilter = false"
				v-if="isShowFilter"
			>
				<div slot="header">
					<h3><i class="material-icons">filter_list</i>Filter Products</h3>
				</div>
				<div slot="body">
					<!-- Categories -->
					<product-category
						:data="selectedCategory"
						@change="onCategoryChange"
					/>
					<!-- Is Public -->
					<div class="form-group" v-if="isStorefrontActive">
						<label class="font-weight-bold">Storefront Visibility</label>
						<select class="form-control" v-model="publicStatus">
							<option
								v-for="(item, index) in publicOptions"
								:key="index"
								:value="item.key"
							>
								{{ item.label }}
							</option>
						</select>
					</div>
					<div class="form-group">
						<label for="">
							<b class="">
								Status Deleted
							</b>
						</label>
						<select class="form-control" v-model="deleted">
							<option value="all">All</option>
							<option value="1">Deleted Product</option>
							<option value="0">Active Product</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowFilter = false"
					>
						{{ $t('Close') }}
					</button>
					<button type="button" class="btn btn-primary" @click="applyFilter">
						Apply Filter
					</button>
				</div>
			</modal>

			<!-- Import Products -->
			<products-import-modal
				@close="isImportVisible = false"
				v-if="isImportVisible"
			/>

			<!-- Empty Default Shipping Alert -->
			<default-shipping-alert-modal
				@close="isDefaultShippingAlertVisible = false"
				v-if="isDefaultShippingAlertVisible"
			/>

			<!-- Product Shipping -->
			<product-shipping-modal
				:product-ids="selectedProducts"
				v-if="isProductShippingVisible"
				@close="isProductShippingVisible = false"
			/>

			<!-- Product Patyments -->
			<product-payments-modal
				:product-ids="selectedProducts"
				v-if="isProductPaymentsVisible"
				@close="isProductPaymentsVisible = false"
			/>

			<!-- Product Detail -->
			<product-item-detail
				:product="productDetail"
				:is-loading-detail="isFetchingLink"
				:isDetailSeller="true"
				@close="isShowDetail = false"
				v-if="isShowDetail"
			/>
		</div>

		<notifications group="products" position="bottom right" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
import ProductTracking from '@/components/ProductTracking.vue';
import ProductBelongsTo from '@/components/ProductBelongsTo.vue';
import ProductItemDetail from '@/components/homepages/sections/partials/ProductItemDetail.vue';
// import Overview from '@/components/Overview.vue';
import ProductCategory from '@/components/ProductCategory.vue';
import CheckboxToggle from '@/components/CheckboxToggle.vue';
import Badges from '@/components/products/Badges.vue';
import userApi from '@/api/user';
import productsApi from '@/api/products';
import { defaultCategory, supplierOverviewKeys, dropshipperOverviewKeys } from '@/lib/statics';
import ProductStats from '@/components/stats/ProductStats.vue';
import statsApi from '@/api/statistic';
import {
	getCheckoutUrl,
	getProductStock,
	getDateRange,
	formatNumber,
	duplicateVar,
	downloadFile,
	getProductDisplayStatus,
} from '@/lib/helper';

const ProductFollowUp = () => import(/* webpackChunkName: "followUp" */ '@/components/ProductFollowUp.vue');
const ProductsImportModal = () => import(
		/* webpackChunkName: "products-import" */ '@/components/ProductsImportModal.vue'
	);
const DefaultShippingAlertModal = () => import(
		/* webpackChunkName: "default-shipping-alert" */ '@/components/DefaultShippingAlertModal.vue'
	);
const ProductShippingModal = () => import(
		/* webpackChunkName: "product-shipping-modal" */ '@/components/ProductShippingModal.vue'
	);
const ProductPaymentsModal = () => import(
		/* webpackChunkName: "product-payments-modal" */ '@/components/ProductPaymentsModal.vue'
	);

const defaultFilterDate = getDateRange();

export default {
	name: 'products',
	components: {
		Modal,
		Daterangepicker,
		// Overview,
		ProductTracking,
		ProductBelongsTo,
		ProductFollowUp,
		ProductCategory,
		CheckboxToggle,
		ProductsImportModal,
		DefaultShippingAlertModal,
		ProductShippingModal,
		ProductPaymentsModal,
		ProductItemDetail,
		Badges,
		ProductStats,
	},
	data() {
		return {
			productName: '',
			keyword: '',
			productIds: '',
			limit: 25,
			sort_by: 'created_at',
			sort: 'asc',
			filterDate: defaultFilterDate,
			isShowDeleteProduct: false,
			isShowDuplicateProduct: false,
			isShowDeleteProductBulk: false,
			isShowArchiveProductBulk: false,
			isArchiveLoading: false,
			isShowStock: false,
			selectedProduct: null,
			selectedProducts: [],
			isDeleting: false,
			isFetchingForms: false,
			isDuplicatingProduct: false,
			isRouteChecked: false,
			isFetchingStock: false,
			stockHistories: [],
			totalProducts: 0,
			totalQtySold: 0,
			totalPaidOrder: 0,
			isShowTracking: false,
			isShowAssignation: false,
			members: [],
			belongsTo: [],
			orderDistribution: {},
			isShowFollowUp: false,
			isShowFilter: false,
			selectedCategory: duplicateVar(defaultCategory),
			isShowEditVisibility: false,
			isShowProductReseller: false,
			isVisible: true,
			isReseller: true,
			isSaving: false,
			isSavingVisibility: false,
			publicStatus: 'all',
			publicOptions: [
				{ key: 'all', label: 'All' },
				{ key: 'visible', label: 'Visible' },
				{ key: 'invisible', label: 'Not Visible' },
			],
			isExporting: false,
			isImporting: false,
			isImportVisible: false,
			isDefaultShippingAlertVisible: false,
			newProducts: [],
			isProductShippingVisible: false,
			isProductPaymentsVisible: false,
			isShowDetail: false,
			stats: {},
			status: '',
			statusOverview: '',
			deleted: '0',
			isFetchingLink: false,
			productDetail: {},
		};
	},
	sockets: {
		product_add(product) {
			this.newProducts.push(product);
		},
	},
	methods: {
		...mapActions({
			getProducts: 'products/getProducts',
			resetProducts: 'products/resetProducts',
			delete: 'products/delete',
			setStorefrontStatus: 'setStorefrontStatus',
		}),
		fetchStats() {
			/* const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat); */

			const params = {
				/* since: startDate,
				until: endDate, */
			};

			const callback = (response) => {
				this.stats = response.data;
				this.checkStats();
			};

			const errorCallback = (e) => {
				console.log(e);
			};

			statsApi.getSupplierProductsStats(params, callback, errorCallback);
		},
		overviewAction(key) {
			this.status = key;

			this.statusOverview = key;
			if (this.status === 'request' && !this.isVerified) {
				this.statusOverview = 'verification';
			}
			if (this.status === 'request' && this.isVerified) {
				this.statusOverview = 'updated';
			}
			this.applyFilter();
		},
		initData() {
			if (this.categoryParam) {
				this.selectedCategory.category_slug = this.categoryParam;
			}
			if (this.subCategoryParam) {
				this.selectedCategory.sub_category_slug = this.subCategoryParam;
			}
			if (this.subSubCategoryParam) {
				this.selectedCategory.sub_sub_category_slug = this.subSubCategoryParam;
			}
			if (this.isPublicQuery) {
				this.publicStatus = this.isPublicQuery === '1' ? 'visible' : 'invisible';
			}
			if (this.productIdsParam) {
				this.productIds = this.productIdsParam;
			}
		},
		getParams() {
			/* const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat); */

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				/* since: startDate,
				until: endDate, */
			};

			if (this.keyword && this.keyword !== '') {
				params.keyword = this.keyword;
			}
			if (this.status && this.status !== 'all') {
				params.status = this.status;
			}

			if (this.statusOverview === 'verification') {
				params.is_verified = false;
				params.status = 'request';
			}

			if (this.statusOverview === 'updated') {
				params.is_verified = true;
				params.status = 'request';
			}

			if (this.statusOverview === 'out_of_stock') {
				params.is_out_of_stock = true;
				params.status = '';
			}

			if (this.statusOverview === 'private') {
				params.visibility = 'private';
				params.status = '';
			}

			if (this.productIds && this.productIds !== '') {
				params.product_ids = this.productIds;
			}

			if (this.selectedCategory.category_slug) {
				params.category_slug = this.selectedCategory.category_slug;
			}
			if (this.selectedCategory.sub_category_slug) {
				params.sub_category_slug = this.selectedCategory.sub_category_slug;
			}
			if (this.selectedCategory.sub_sub_category_slug) {
				params.sub_sub_category_slug = this.selectedCategory.sub_sub_category_slug;
			}

			if (this.publicStatus !== 'all') {
				params.is_public = this.publicStatus === 'visible' ? 1 : 0;
			}

			if (this.deleted && this.deleted === '1') {
				params.is_deleted = true;
			} else if (this.deleted && this.deleted === '0') {
				params.is_deleted = false;
			}

			return params;
		},
		fetchProducts(reset = true) {
			if (reset) {
				this.resetProducts();
			}
			const params = this.getParams();
			this.getProducts(params);
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetchProducts();
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchProducts(false);
				}
			}
		},
		bulkDelete() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				for (let i = 0; i < this.selectedProducts.length; i++) {
					const id = this.selectedProducts[i];
					const index = this.products.findIndex(
						product => product._id.$oid === id,
					);
					const isIndex = index !== -1;
					if (isIndex) {
						this.delete(index);
					}
				}
				this.$set(this, 'selectedProducts', []);

				this.isShowDeleteProductBulk = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Products deleted',
					type: 'success',
				});
			};
			productsApi.bulkDelete(this.selectedProducts.slice(), callback);
		},
		bulkArchive() {
			this.isArchiveLoading = true;
			const callback = () => {
				this.isArchiveLoading = false;
				for (let i = 0; i < this.selectedProducts.length; i++) {
					const id = this.selectedProducts[i];
					const index = this.products.findIndex(
						product => product._id.$oid === id,
					);
					const isIndex = index !== -1;
					if (isIndex) {
						this.fetchProducts();
					}
				}
				this.$set(this, 'selectedProducts', []);

				this.isShowArchiveProductBulk = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Products archived',
					type: 'success',
				});
			};
			productsApi.bulkArchive(this.selectedProducts.slice(), callback);
		},
		deleteProduct() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				const id = this.selectedProduct._id.$oid;
				const index = this.products.findIndex(
					product => product._id.$oid === id,
				);
				const isIndex = index !== -1;
				if (isIndex) {
					this.delete(index);
				}
				this.$set(this, 'selectedProduct', null);

				this.isShowDeleteProduct = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Product deleted',
					type: 'success',
				});
			};
			productsApi.bulkDelete([this.selectedProduct._id.$oid], callback);
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchProducts(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		checkoutUrlFull(slug) {
			return getCheckoutUrl(this.user.username, slug);
		},
		showConfirmDeleteProduct(product) {
			this.selectedProduct = product;
			this.isShowDeleteProduct = true;
		},
		showConfirmDuplicateProduct(product) {
			this.selectedProduct = product;
			this.isShowDuplicateProduct = true;
		},
		duplicateProduct(productId) {
			this.isDuplicatingProduct = true;
			const callback = (response) => {
				// this.products.push(response.data);
				const message = response.message;
				this.isDuplicatingProduct = false;
				this.isShowDuplicateProduct = false;
				this.$notify({
					group: 'products',
					title: 'Product',
					text: message,
					type: 'success',
				});
				this.fetchStats();
				this.fetchProducts();
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				const message = e.response.data.message;
				this.isDuplicatingProduct = false;
				this.isShowDuplicateProduct = false;
				this.$notify({
					group: 'products',
					title: 'Product',
					text: message,
					type: 'error',
				});
			};

			productsApi.duplicate(productId, callback, errorCallback);
		},
		checkCapabilities() {
			if (!this.isUserCan('product_view')) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		getStockQuantity(product) {
			const isSimple = product.type === 'simple';
			const variantQuantity = product.variations.prices.reduce(
				(prevQty, variation) => {
					const variationQuantity = variation.stock
						? variation.stock.quantity
						: 0;
					const totalQuantity = prevQty + variationQuantity;
					return totalQuantity;
				},
				0,
			);
			const quantity = isSimple ? product.stock.quantity : variantQuantity;
			return quantity;
		},
		getStockQuantityClass(product) {
			const quantity = this.getStockQuantity(product);
			const className = quantity > 0 ? 'text-success' : 'text-danger';
			// if (quantity === 0) {
			// 	className = 'text-danger';
			// } else if (quantity < 10) {
			// 	className = 'text-warning';
			// }
			return className;
		},
		showStock(product) {
			this.selectedProduct = product;
			this.isShowStock = true;
			// this.fetchStockHistory(product._id);
		},
		formatNumber(number) {
			return formatNumber(number, 0, ',', '.');
		},
		initFilterDate() {
			if (this.since && this.since !== '' && this.until && this.until !== '') {
				const since = this.moment(this.since);
				const until = this.moment(this.until);
				const filterDate = {
					start: since,
					end: until,
				};
				this.filterDate = filterDate;
			}
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const format = 'YYYY-MM-DD';
			const since = this.moment(filterDate.start).format(format);
			const until = this.moment(filterDate.end).format(format);
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchProducts();
			this.fetchStats();
		},
		onCategoryChange(category) {
			if (category.type === 'category') {
				this.selectedCategory.category = category.name;
				this.selectedCategory.category_slug = category.slug;
			} else if (category.type === 'sub_category') {
				this.selectedCategory.sub_category = category.name;
				this.selectedCategory.sub_category_slug = category.slug;
			} else if (category.type === 'sub_sub_category') {
				this.selectedCategory.sub_sub_category = category.name;
				this.selectedCategory.sub_sub_category_slug = category.slug;
			}
		},
		applyFilter() {
			const query = {};

			// Category
			if (this.selectedCategory.category_slug !== '') {
				query.category = this.selectedCategory.category_slug;
			} else {
				delete query.category;
			}

			// Sub Category
			if (this.selectedCategory.sub_category_slug !== '') {
				query.sub_category = this.selectedCategory.sub_category_slug;
			} else {
				delete query.sub_category;
			}

			// Sub Sub Category
			if (this.selectedCategory.sub_sub_category_slug !== '') {
				query.sub_sub_category = this.selectedCategory.sub_sub_category_slug;
			} else {
				delete query.sub_sub_category;
			}

			if (this.publicStatus !== 'all') {
				query.is_public = this.publicStatus === 'visible' ? 1 : 0;
			} else {
				delete query.is_public;
			}

			const params = { query };
			this.$router.push(params);
			this.isShowFilter = false;

			this.fetchProducts(true);
			this.fetchStats();
		},
		clearFilter() {
			// Categories
			this.selectedCategory = duplicateVar(defaultCategory);
			this.productIds = '';
			this.applyFilter();
		},
		fetchStorefrontStatus() {
			const addonId = '5c359d8e215076fe8903d779'; // Storefront
			const callback = (response) => {
				const isActive = response.data.is_active;
				this.setStorefrontStatus(isActive);
			};
			userApi.getAddonStatus(addonId, callback);
		},
		updateVisibility() {
			this.isSavingVisibility = true;
			const productIds = JSON.stringify(this.selectedProducts);
			const params = {
				product_ids: productIds,
				is_public: this.isVisible,
			};
			const callback = () => {
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Product Visibility',
					text: 'Updated successfully',
				});
				this.isSavingVisibility = false;
				this.isShowEditVisibility = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Product Visibility',
					text: 'Something error, please try again',
				});
				this.isSavingVisibility = false;
			};
			productsApi.updateVisibilityBulk(params, callback, errorCallback);
		},
		updateProductReseller() {
			this.isSaving = true;
			const productIds = JSON.stringify(this.selectedProducts);
			const params = {
				product_ids: productIds,
				reseller: this.isReseller,
			};
			const callback = () => {
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Product Reseller',
					text: 'Updated successfully',
				});
				this.isSaving = false;
				this.isShowProductReseller = false;
			};
			const errorCallback = (e) => {
				console.log(e);
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Product Reseller',
					text: 'Something error, please try again',
				});
				this.isSaving = false;
			};
			productsApi.updateResellerProductBulk(params, callback, errorCallback);
		},
		exportProducts(type) {
			this.isExporting = true;
			const getParams = this.getParams();
			const params = duplicateVar(getParams);
			params.file_type = type;
			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			productsApi.exportProducts(params, callback, errorCallback);
		},
		refreshPage() {
			window.location.reload();
		},
		getProductDisplayStatus,
		isShowMarketingKit(product) {
			return this.user && product.marketing_kit !== undefined && product.marketing_kit?.visible;
		},
		showProductDetail(product) {
			const sourceId = product?.source_id?.$oid;
			const visibility = product?.visibility ?? 'public';
			this.getProductBySourceId(sourceId, visibility, false);

			this.selectedProduct = product;
			this.isShowDetail = true;
		},
		openProductsImportModal() {
			if (this.isHasStoreAddress) {
				this.isImportVisible = true;
			} else {
				this.isDefaultShippingAlertVisible = true;
			}
		},
		openLinkProduct(product) {
			const sourceId = product?.source_id?.$oid;
			const visibility = product?.visibility ?? 'public';
			this.getProductBySourceId(sourceId, visibility);
		},
		getProductBySourceId(sourceId, visibility = 'public', openLink = true) {
			this.isFetchingLink = true;

			const params = {
				limit: 1,
				page: 1,
				product_ids: [sourceId],
				visibility,
			};

			const cb = (resp) => {
				this.isFetchingLink = false;
				this.productDetail = resp.data ? resp.data.products[0] : null;
				if (openLink) {
					this.showDetail(this.productDetail);
				}
			};

			const errorCb = () => {
				this.isFetchingLink = false;
				this.$notify({
					group: 'products',
					text: 'Product Not found',
					type: 'error',
				});
			};

			productsApi.getPublicProducts(params, cb, errorCb);
		},
		showDetail(product) {
			const encodedUserId = window.btoa(product?.user?._id?.$oid);
			const slug = `${product.slug}-${encodedUserId}`;
			const route = {
				name: 'product-detail',
				params: {
					slug,
				},
			};

			const visibility = product?.visibility;
			if (visibility === 'private') {
				route.query = {
					visibility,
				};
			}

			const productUrl = this.$router.resolve(route).href;
			window.open(productUrl, '_blank');
		},
		checkStats() {
			const products = this.stats?.products;
			if (products && this.isDropshipper) {
				products.active_count = products?.active_count - products?.out_of_stock_count;
				products.private_count = products?.private_without_out_of_stock_count ?? products?.private_count;
				this.stats.products = products;
			}
		},
		isHideProduct(product) {
			const ownerTypeCondition = this.isDropshipper;
			const statusOverviewCondition = (this.statusOverview !== 'out_of_stock' && this.statusOverview !== 'all');
			const stockCondition = this.getStockQuantity(product) <= 0;
			const isHide = ownerTypeCondition && statusOverviewCondition && stockCondition;

			return isHide;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			appProject: 'appProject',
			isAdmin: 'isAdmin',
			isOwner: 'isOwner',
			isUserCan: 'isUserCan',
			isHasFeature: 'isHasFeature',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			products: 'products/allProducts',
			isFetching: 'products/isFetching',
			isAll: 'products/isAll',
			page: 'products/page',
			pageInfo: 'products/pageInfo',
			isFetched: 'products/isFetched',
			filterDatePresets: 'filterDatePresets',
			pixelIds: 'pixelIds',
			pixelEvents: 'pixelEvents',
			gtmIds: 'gtmIds',
			isStorefrontActive: 'isStorefrontActive',
			isTester: 'isTester',
			isHasStoreAddress: 'isHasStoreAddress',
		}),
		selectAll: {
			get() {
				return this.products
					? this.selectedProducts.length === this.products.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.products.forEach((product) => {
						if (!this.isHideProduct(product)) {
							selected.push(product._id.$oid);
						}
					});
				}
				this.selectedProducts = selected;
			},
		},
		isCanDeleteProduct() {
			return this.isUserCan('product_delete');
		},
		selectedProductsData() {
			const filter = (product) => {
				const isSelected = this.selectedProducts.find(
					selected => selected === product._id.$oid,
				);
				return isSelected;
			};
			const products = this.products.filter(filter);
			return products;
		},
		isCanDelete() {
			return this.selectedProductsData.every(item => item.submission_count === undefined || item.submission_count < 1);
		},
		isCanArchive() {
			return this.selectedProductsData.every(item => item.submission_count !== undefined || item.submission_count > 1);
		},
		selectedProductStock() {
			const stock = getProductStock(this.selectedProduct);
			return stock;
		},
		since() {
			const since = this.$route.query.since;
			return since;
		},
		until() {
			const until = this.$route.query.until;
			return until;
		},
		categoryParam() {
			return this.$route.query.category;
		},
		subCategoryParam() {
			return this.$route.query.sub_category;
		},
		subSubCategoryParam() {
			return this.$route.query.sub_sub_category;
		},
		productIdsParam() {
			return this.$route.query.product_ids;
		},
		isPublicQuery() {
			return this.$route.query.is_public;
		},
		isFilterOn() {
			return (
				this.categoryParam
				|| this.subCategoryParam
				|| this.subSubCategoryParam
				|| this.productIdsParam
			);
		},
		productStatsOverviews() {
			const overviews = this.isSupplier ? supplierOverviewKeys : dropshipperOverviewKeys;

			return overviews;
		},
		isShowInfo() {
			const isShow = !this.isDropshipper;

			return isShow;
		},
	},
	watch: {
		user() {
			this.initFilterDate();
			this.checkCapabilities();
			this.fetchStorefrontStatus();
		},
		pageInfo(pageInfo) {
			const totalProducts = pageInfo.total_all_products;
			this.totalProducts = totalProducts;
			this.totalQtySold = pageInfo.total_quantity_sold;
			this.totalPaidOrder = pageInfo.total_paid_order;
		},
		'$route.query': {
			handler() {
				this.initData();
				this.fetchProducts();
			},
		},
	},
	created() {
		this.initData();
		if (this.user) {
			this.initFilterDate();
			this.checkCapabilities();
			// this.fetchStorefrontStatus();
		}
		// Fetch Products
		this.fetchProducts();
		this.fetchStats();
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
	.deleted {
		color: #ff1744;
	}
	.deleted i{
		font-size: 12px;
	}
</style>
